<template>
  <div class="home">
    <van-nav-bar
      :title="$t('ShopList.RechargeAmountSetting')"
      left-arrow
      fixed
      @click-left="$router.push('/ShopSet/' + sessionStorage.actShopId)"
    >
      <van-button
        type="default"
        color="#1989fa"
        @click="$router.push('/addRechargeAmount')"
        slot="right"
      >
        {{ $t("ShopList.add") }}
      </van-button>
    </van-nav-bar>
    <div class="RechargeAmount-main">
      <template>
        <el-table :data="RechargeAmountList" stripe style="width: 100%" border>
          <el-table-column
            prop="order_number"
            :label="$t('member.number')"
            width="80px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            :label="$t('member.name')"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="price"
            :label="$t('member.PaymentAmount')"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="amount"
            :label="$t('member.RechargeAmount')"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="discount"
            :label="$t('member.Discount')"
            align="center"
          >
          </el-table-column>
          <el-table-column :label="$t('member.Switch')" align="center">
            <template slot-scope="scope">
              <van-switch
                v-model="scope.row.status"
                size="20"
                @click="recharge(scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('member.Operate')"
            align="center"
            fixed="right"
            width="100px"
          >
            <template slot-scope="scope">
              <van-button type="info" @click="toUpdateRecharge(scope.row)">
                {{ $t("EditTable.certainBtn") }}
              </van-button>
              <van-button type="danger" @click="toDelete(scope.row)">
                {{ $t("ShopList.delete") }}
              </van-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
    <van-dialog
      v-model="show"
      :title="$t('member.ConfirmWhetherToDelete')"
      show-cancel-button
      :confirm-button-text="$t('vantText.confirm')"
      :cancel-button-text="$t('vantText.cancel')"
      @confirm="Delete"
    >
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      actShopId: "",
      RechargeAmountList: [],
      deleteData: [],
      show: false
    };
  },
  mounted: function() {
    this.actShopId = sessionStorage.getItem("actShopId");
    this.getAceeghrr();
  },
  methods: {
    // 获取充值金额列表
    getAceeghrr() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + `/api/recharge/${this.actShopId}/index`
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.RechargeAmountList = res.data.data;
            this.RechargeAmountList.forEach(item => {
              item.status = item.status == 0 ? false : true;
            });
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 开关
    recharge(item) {
      let data = {
        name: item.name,
        price: item.price,
        amount: item.amount,
        discount: item.discount,
        status: item.status,
        order_number: item.order_number
      };
      data.status = data.status ? 0 : 1;
      this.$axios({
        method: "patch",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + `/api/recharge/${item.id}/update`,
        data: data
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 跳转到修改界面
    toUpdateRecharge(item) {
      // 带查询参数，传递过去的内容会自动拼接变成/home?user=david
      let list = JSON.stringify(item);
      this.$router.push({ path: "/addRechargeAmount", query: { list: list } });
    },
    // 删除弹窗
    toDelete(item) {
      this.deleteData = item;
      this.show = true;
    },
    // 删除充值金额
    Delete(item) {
      this.$axios({
        method: "delete",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + `/api/recharge/${this.deleteData.id}/destroy`
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.getAceeghrr();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  color: #fff;
}
/deep/ .van-nav-bar__right {
  padding: 0;
}
/deep/ .van-button {
  height: 2.1875rem;
}
/deep/ .van-col {
  /* text-align: center; */
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
}
/deep/ .van-button {
  margin: 5px 0px;
}
.title {
  background: #fff;
}
.mbottom {
  margin-bottom: 10px;
}
.card {
  display: flex;
  padding: 10px 0px;
  background: #fff;
}
.card_left {
  width: 80%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
}
.name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.card_left > span {
  width: 30%;
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 10px;
}
.card_right {
  display: flex;
  width: 20%;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/Shop/RechargeAmountSetting.vue